import { LoginPage } from "../pages/login/login-page";
import { OnboardingPage } from "../pages/onboarding/onboarding-page";
import { NutritionPage } from "../pages/nutrition/nutrition-page";
import { PortalPage } from "../pages/portal/portal-page";

export const ROUTES = {
  LOGIN: {
    PATH: "/login",
    COMPONENT: LoginPage,
  },
  PORTAL: {
    PATH: "/portal",
    COMPONENT: PortalPage,
    ROUTES: {
      ONBOARDING: {
        PATH: "/portal/onboarding",
        COMPONENT: OnboardingPage,
      },
      NUTRITION: {
        PATH: "/portal/nutrition",
        COMPONENT: NutritionPage,
      },
    },
  },
};
